import React from "react";
import { observer } from "mobx-react";
import { PageLayout } from "../../../../common/layout";
import { useRootStore } from "../../../../store/contexts";
import { EditionTypeView } from "./EditionTypeView";
import { EditionTypeViewStore } from "../../store/EditionTypeViewStore";
import { useStore } from "../../../../hooks";

export const EditionTypeViewPage = observer(() => {
  const rootStore = useRootStore();
  const { router } = rootStore;

  const id = router.params?.id as string;
  const path = `/editionType/view/${id}`;

  const store = useStore(
    path,
    () => {
      const s = new EditionTypeViewStore(rootStore);
      return s;
    },
    { id }
  );

  return (
    <div>
      <PageLayout
        navigationElements={{
          links: [],
          onNavigatedTo: (id) => {
            store.setCardState(id, true);
          },
        }}
      >
        <EditionTypeView editionTypeViewStore={store} />
      </PageLayout>
    </div>
  );
});
